export const EDITOR_PURIFY_CONFIG = {
  ALLOWED_TAGS: [
    'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'ul', 'ol',
    'td', 'th', 'tr', 'table', 'thead', 'tbody', 'blockquote',
    'div', 'span', 'br', 'section', 'article', 'header', 'footer', 
    'style', 'hr', 'em', 'strong', 'sub', 'sup', 'b', 'i'
  ],
  ALLOWED_ATTR: [
    'class', 'style', 'id', 'data-original', 'align', 'valign',
    'width', 'height', 'cellpadding', 'cellspacing', 'border'
  ],
  FORCE_BODY: true,
  ADD_TAGS: ['style'], // Ensure style tags are preserved
  ADD_ATTR: ['contenteditable']
};